// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-fjnQ","col":"styles_col__i6Uih","actions":"styles_actions__1K2rs","conflict":"styles_conflict__3H7TJ"};